import { useQuery } from '@tanstack/react-query';
import { fetchChecklistPhoto } from '@apis/checklists';
import { useObjectUrl } from '@hooks/useObjectUrl';
import type { ITaskAttachment } from '@interfaces/IScheduler';

/**
 * A stored checklist photo. Its `url` is an API path, so the bytes are fetched
 * with the session (the API lives on another origin than the page) and shown
 * through an object URL. Evidence never changes once stored — cached for good.
 */
export function EvidencePhoto({ photo, alt, className }: { photo: ITaskAttachment; alt: string; className?: string }) {
  const { data } = useQuery({
    queryKey: ['checklists', 'evidence', photo.url],
    queryFn: ({ signal }) => fetchChecklistPhoto(photo.url, signal),
    staleTime: Infinity,
  });
  const src = useObjectUrl(data);
  return src ? <img className={className} src={src} alt={alt} /> : <span className={className} aria-busy="true" />;
}
